import {EmptyProps} from "../../common/empty/Empty.props";
import {ListColumnType, ListHeader} from "../../common/list/List.props";

export const HEADERS: ListHeader[] = [
    {
        type: ListColumnType.CHECK_BOX,
        name: "",
        key: ""
    },
    {
        type: ListColumnType.LONG_TEXT,
        name: "게시글 이름",
        key: "title"
    }
];

export const EMPTY_PROPS = (handleButtonClick: () => void): EmptyProps => {
    return {
        messageText: "공지사항이 없습니다.",
        buttonText: "공지사항 추가하기",
        handleButtonClick: handleButtonClick
    };
}